import { DB as db } from "../config/constants";
const APP_URL = process.env.REACT_APP_URL;
export const getTransactionsBySender = async (id, sender) => {
  const url =
    `${APP_URL}/transactions_by_sender`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      sender,
      db,
    }),
  });

  const result = await response.json();
  return result;
};
export const getTransactions = async (id, agency, from, to) => {
  const url =
    `${APP_URL}/transactions_by_period`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      agency: agency,
      from: from,
      to: to,
      db,
    }),
  });

  const result = await response.json();
  return result;
};
export const get_kyc_by_id = async (kycId) => {
  const url =
    `${APP_URL}/get_kyc_by_id`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      kycId,
      db,
    }),
  });

  const result = await response.json();
  return result;
};

export const getAggregationsBySender = async (id, sender) => {
  const url =
    `${APP_URL}/aggregations_by_sender`

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      sender: sender,
      db,
    }),
  });

  const result = await response.json();

  return result;
};

export const aggregationEdit = async (id, comments) => {
  const url =
    `${APP_URL}/aggregation_edit`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      comments: comments,
      db,
    }),
  });

  const result = await response.json();

  return result;
};

export const aggregationKyc = async (name, kyc, kycId) => {
  const url =
    `${APP_URL}/aggregation_kyc`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      kyc,
      kycId,
      db,
    }),
  });

  const result = await response.json();

  return result;
};

export const getAggregations = async (id, agency, from, to) => {
  const url =
    `${APP_URL}/aggregation_by_period`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      agency: agency,
      from: from,
      to: to,
      db,
    }),
  });

  const result = await response.json();

  return result;
};

export const insertAggregation = async (content, id) => {
  const url =
    `${APP_URL}/insert_aggregation`
  const records = content.map((r) => {
    r.agent_id = id;
    r.db = db;
    return r;
  });

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      db,
      data: records,
    }),
  });

  const result = await response.json();
  return result;
};

export const insertTransaction = async (content, setRawTransaction) => {
  const url =
    `${APP_URL}/insert_transaction`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      db,
      data: content,
    }),
  });

  const result = await response.json();
  if (result.body === "success") {
    return content;
  }
};

export const login = async (credentials, setUser) => {
  const url =
    `${APP_URL}/login`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  });

  const result = await response.json();

  return result;
};

export const insertKyc = async (content) => {
  const url =
    `${APP_URL}/insert_kyc`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      db,
      data: [content],
    }),
  });

  const result = await response.json();
  return result;
};

export const getKycList = async (id) => {
  const url =
    `${APP_URL}/get_kyc_list`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      db,
      agent_id: id,
    }),
  });

  const result = await response.json();
  return result;
};

export const downloadMSBReport = (formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = 'https://msb.evdpl.com/wp-json/mymsb/v1/data';

      const response = await fetch(url, { method: "POST", body: formData });

      if (!response.ok) {
        reject('Network response was not ok');
      }

      const blob = await response.blob();
      resolve(blob);
    } catch (error) {
      reject(error.message)
    }
  });
}

export const userAuthentication = async (reqBody) => {
  const url =
    `${APP_URL}/user_authentication`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(reqBody),
  });

  const result = await response.json();

  return result;
};


export const createUser = async (reqBody) => {
  const url = `${APP_URL}/create_user`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(reqBody),
  });
  const result = response.json();
  return result;
}

export const deleteTransactions = async (id, from, to) => {
  const url = `${APP_URL}/delete_transactions`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      agent_id: id,
      from: from,
      to: to,
      db,
    }),
  });
  const result = response.json();
  return result
};

export const transactions = async (agent_id) => {
  const url = `${APP_URL}/transactions`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ agent_id }),
  });
  const result = response.json();
  return result;
}

export const aggregations = async (agent_id) => {
  const url = `${APP_URL}/aggregations`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ agent_id }),
  });
  const result = response.json();
  return result;
}